import { render } from "./Quote.vue?vue&type=template&id=5497a999"
import script from "./Quote.vue?vue&type=script&lang=js"
export * from "./Quote.vue?vue&type=script&lang=js"
script.render = render

export default script